import { canAccess } from 'src/enterprise/ra-rbac';
import * as React from 'react';
import { CommonInputProps, usePermissions, useResourceContext, useRecordContext } from 'react-admin';

type RbacProps = {
    children: React.ReactNode;
    sx?: Object;
};

export const RbacWrapperForm = (props:RbacProps) => {
    const { sx, ...rest } = props;
    let children = props.children;

    const resourceFromContext = useResourceContext();
    const recordFromContext = useRecordContext();
    const { permissions } = usePermissions();

    const renderChildren = (children) => {
        return React.Children.map(children, (input: React.ReactElement) => {
            if (typeof (input.props as any).source === 'undefined' && (input.props as any).children) {
                
                return (
                    <input.type {...input.props}>
                        {renderChildren((input.props as any).children)}
                    </input.type>
                )
            } else {
                return input &&
                canAccess({
                    permissions,
                    action: 'write',
                    resource: `${resourceFromContext}.${(input.props as any).source}`,
                    record: recordFromContext,
                })
                    ? input
                    : null

                }
            }
        )
    }

    if(!children)
        return (<></>);

    if(!Array.isArray(children))
        children = [children];

    return (
        <>
            {renderChildren(children)}
        </>
    );
};